var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.46 91.46",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{stroke:#808db1;stroke-width:4px;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:none;}.cls-1,.cls-3,.cls-5{stroke-miterlimit:10;}.cls-3,.cls-5{stroke-linecap:round;}.cls-4,.cls-6{stroke-width:0px;}.cls-5{stroke:#fff;stroke-width:2px;}.cls-6{fill:#808db1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1340",
    className: "cls-1",
    x: 3.79,
    y: 3.23,
    width: 83.88,
    height: 85,
    rx: 1.22,
    ry: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1341",
    className: "cls-1",
    x: 11.63,
    y: 14.21,
    width: 68.22,
    height: 24.81,
    rx: 1.22,
    ry: 1.22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1342"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 62.03,
    y: 19.82,
    width: 13.18,
    height: 13.6,
    rx: 0.76,
    ry: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 63.68,
    y: 21.46,
    width: 9.89,
    height: 10.31,
    rx: 0.89,
    ry: 0.89
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1369"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1342-2",
    className: "cls-6",
    x: 62.03,
    y: 58.04,
    width: 13.18,
    height: 13.6,
    rx: 0.76,
    ry: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5748",
    className: "cls-5",
    d: "m64.46,64.91l2.63,2.63c.06.07.17.07.23,0,0,0,0,0,0,0l5.46-5.46"
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_393",
    className: "cls-3",
    x1: 20.58,
    y1: 26.18,
    x2: 29.4,
    y2: 26.18
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_394",
    className: "cls-3",
    x1: 36.91,
    y1: 26.18,
    x2: 54.58,
    y2: 26.18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1343",
    className: "cls-1",
    x: 11.63,
    y: 52.43,
    width: 68.22,
    height: 24.81,
    rx: 1.22,
    ry: 1.22
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_395",
    className: "cls-3",
    x1: 20.58,
    y1: 64.39,
    x2: 39.81,
    y2: 64.39
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_396",
    className: "cls-3",
    x1: 47.58,
    y1: 64.39,
    x2: 54.58,
    y2: 64.39
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "info.f37da289ae36b4b0262d7ec09149162f.svg";